import { Injectable } from '@angular/core';
import {
  AuthService,
  CartService,
  CustomerProductPrice,
  GungAnonymousConfigService,
  GungCurrencyPipe,
  PriceConfigService,
  PriceService,
  ProductService
} from 'gung-standard';
import { environment } from '../../environments/environment';
import { GungLanguageConfigService } from 'gung-common';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class CarLinerPriceConfigService extends PriceConfigService {
  protected isThailand = environment.projectName === 'thailand';
  protected isCaroliner = environment.projectName === 'caroliner';
  public enableHidePrice = true;


  protected getDigitsInfo(): string {
    return '1.2-2';
  }

  public getPrice(
    price: CustomerProductPrice | string,
    mode: string,
    display?: string | boolean,
    currency?: string
  ): string {
    const priceObject: boolean = typeof price === 'object';
    const priceValue = priceObject ? price[mode].value ?? price[mode] : price;
    const currencyValue = priceObject ? price[mode].currencyCode : currency;

    let digitsInfo;
    if (Number(Number(priceValue).toFixed(2)) % 1 === 0) {
      digitsInfo = '1.2-2';
    }

    if (priceValue == 0 && display !== 'custom') {
      return '';
    } else if (display === 'custom') {
      display = this.getDisplay();
    }

    return this.currencyPipe.transform(
      priceValue,
      currencyValue || this.getCurrency(),
      'code',
      digitsInfo || this.getDigitsInfo(),
      this.getLocale()
    );
  }

  protected getLocale(): string {
    return (this.isThailand || this.isCaroliner) ? 'he' : super.getLocale();
  }
}
